/* vDEV */
(() => {
  
  window.themeObj = {
    
    init: () => {
      const obj = window.themeObj;
      
      obj.templates.init();
      obj.sections.init();
      obj.apps.init();
    },
    
    templates: {
      
      init: () => {
        const obj = window.themeObj.templates;
  
        if (document.body.classList.contains('template-index')) {
          new obj.index();
        
        } else if (document.body.classList.contains('template-page')) {
          new obj.page();
        
        } else if (document.body.classList.contains('template-product')) {
          new obj.product();
        
        } else if (document.body.classList.contains('template-collection')) {
          new obj.collection();
        }
      },
      
      index: class {
  
        constructor() {
          const obj = this;
  
          obj.okendo();   
        }

        okendo() {
          const obj = this;

          obj.okendoEvent();
          
          document.addEventListener('scroll', () => {
            obj.okendoEvent();
          });
        }

        okendoEvent() {
          const obj = this;

          const popup = document.querySelector('.oke-reviewsTab.oke-reviewsTab--small-top-right');
          const bar = document.querySelector('#section-id-announcement-bar');
          const header = document.querySelector('#shopify-section-header');

          if (!popup || !bar || !header) {
            return false;
          }
          
          const scrollThreshold = header.offsetHeight;
        
          if (window.scrollY > bar.offsetHeight + header.offsetHeight) {
            popup.classList.add('is-scrolled');
            
          } else {
            popup.classList.remove('is-scrolled');
          }
        }
      },
      
      collection: class {

        constructor() {
          const obj2 = this;

          obj2.productBlock();
        }

        productBlock() {
          const obj2 = this;

          class ProductBlock extends HTMLElement {

            constructor() {
              super();

              const obj3 = this;
            }

            connectedCallback() {
              const obj3 = this;

              obj3.colors();
            }

            colors() {
              const obj3 = this;

              const colors = obj3.querySelectorAll('.product-block-options__item');

              if (!colors.length) {
                return;
              }

              colors.forEach((color) => {

                color.addEventListener('click', (event) => {
                  event.preventDefault();

                  const activeColor = color.parentNode.querySelector('.product-block-options__item.is-active');

                  if (activeColor) {
                    activeColor.classList.remove('is-active');
                  }

                  color.classList.add('is-active');

                  const formUrl = `${color.getAttribute('href')}?section_id=product-block`;
                  
                  fetch(formUrl)
                    .then((response) => {
                    
                      if (!response.ok) {
                        return false;
                      }
                      
                      return response.text();
                    })
                    .then(response => {
                      return new DOMParser().parseFromString(response, 'text/html');
                    })
                    .then((response) => {
                      const fetchContent = response.querySelector('.block-inner');
                      
                      if (!fetchContent) {
                        return false;
                      }

                      const fetchImage = fetchContent.querySelector('.image-cont__wrapper');
                      const image = obj3.querySelector('.image-cont__wrapper');
                      image.innerHTML = fetchImage.innerHTML;

                      const fetchLabel = fetchContent.querySelector('.product-label-container');
                      const label = obj3.querySelector('.product-label-container');
                      label.innerHTML = fetchLabel.innerHTML;

                      const fetchTitle = fetchContent.querySelector('.innerer h4');
                      const title = obj3.querySelector('.innerer h4');
                      title.innerHTML = fetchTitle.innerHTML;

                      const fetchPrice = fetchContent.querySelector('.product-price');
                      const price = obj3.querySelector('.product-price');
                      price.innerHTML = fetchPrice.innerHTML;

                      theme.loadCarousels(this);
                      theme.ProductBlockManager.loadImages(this);
                    });
                  });
              });
            }
          }

          if (!customElements.get('product-block')) {
            customElements.define('product-block', ProductBlock);
          }
        }
      },

      page: class {
  
        constructor() {
          const obj = this;
  
          obj.wishlist();   
        }
  
        wishlist() {
          const obj = this;
  
          class WishlistLanding extends HTMLElement {
  
            settings = {
              renderInterval: false,
              renderIntervalCount: 0
            }
  
            constructor() {
              super();
              
              const obj2 = this;
              
              obj2.render();
  
              obj2.settings.renderInterval = setInterval(() => {
                obj2.render();
      
                obj2.settings.renderIntervalCount++;
                
                if (obj2.settings.renderIntervalCount > 25) {
                  clearInterval(obj2.settings.renderInterval);
                }
              }, 500);
            }
  
            render() {
              const obj2 = this;
              
              const items = obj2.querySelectorAll('.swym-ui-component .swym-wishlist-grid li');
              
              if (!items.length) {
                return false;
              }
  
              items.forEach((item, itemI) => {
                obj2.renderItem(item);
      
                setTimeout(obj2.renderItem(item), 100 * itemI);
              });
              
              if (obj2.settings.renderInterval) {
                clearInterval(obj2.settings.renderInterval);
              }
            }
      
            renderItem(item) {
              const obj2 = this;
      
              const itemTitle = item.querySelector('.swym-title').innerHTML.trim();
      
              const formUrlQ = `"${itemTitle}"`;
              const formUrl = `/search?type=product&section_id=main-search&q=${encodeURIComponent(formUrlQ)}`;
              
              fetch(formUrl)
                .then((response) => {
                
                  if (!response.ok) {
                    return false;
                  }
                  
                  return response.text();
                })
                .then(response => {
                  return new DOMParser().parseFromString(response, 'text/html');
                })
                .then((response) => {
                  const fetchContent = response.querySelector(`.product-block[data-product-title="${itemTitle}"] .product-label-container`);
                  
                  if (!fetchContent) {
                    return false;
                  }
      
                  const itemImage = item.querySelector('.swym-wishlist-image-wrapper');
                  itemImage.append(fetchContent);
                });
            }
          }
          
          customElements.define('wishlist-landing', WishlistLanding);
        }
      },
      
      product: class {
  
        constructor() {
          const obj = this;

          obj.sizeGuide();
          obj.gallery();
          
          obj.payments();
          obj.form();
          obj.optionSelector();
          obj.stickyBar();
          obj.giftCardModal();
          obj.fbt();
          obj.accordions();
        }

        fbt() {
          const widgetWrapper = document.querySelector('product-fbt');
          const section = widgetWrapper.closest('.shopify-section');

          document.addEventListener('rebuy.productsChange', function(event){
            const widget = event.detail.widget;
            const widgetId = parseInt(widget.element.dataset.rebuyId);

            if (widgetId != 121973) {
              return;
            }

            if (widget.data.products && widget.data.products.length > 0) {
              section.classList.remove('hidden');
            }
          });
        }

        sizeGuide() {
          const obj = this;

          class ProductSizeGuide extends HTMLElement {

            constructor() {
              super();

              const obj2 = this;
            }
            
            connectedCallback() {
              const obj2 = this;
  
              const links = obj2.querySelectorAll('.product__size-guide__set-item');
    
              if (!links.length) {
                return false;
              }
              
              links.forEach((link) => {
    
                link.addEventListener('click', () => {
                  const linkI = link.getAttribute('data-i');
                  
                  const activeLink = link.parentNode.querySelector('.is-active');
                  activeLink.classList.remove('is-active');
                  
                  link.classList.add('is-active');
                  
                  const activeTable = obj2.querySelector('.product__size-guide__table.is-active');
                  activeTable.classList.remove('is-active');
                  
                  const table = obj2.querySelector(`.product__size-guide__table[data-i="${linkI}"]`);
                  table.classList.add('is-active');
                });
              });
            }
          }
          
          if (!customElements.get('product-size-guide')) {
            customElements.define('product-size-guide', ProductSizeGuide);
          }
        }
  
        gallery() {
          const obj = this;

          let hoverTimer = null;
          let isZooming = false;

          const wrapper = document.querySelector('.product-media__zoom');
          const img = document.querySelector('.product-media__zoom img');
          const lens = document.querySelector('.product-media__zoom-lens');
          
          const zoom = 3; // Magnification level
          
          lens.style.backgroundImage = `url(${wrapper.getAttribute('data-zoom-url')})`;
          lens.style.backgroundSize = `${wrapper.offsetWidth * zoom}px ${wrapper.offsetHeight * zoom}px`;

          wrapper.addEventListener('mouseenter', () => {
            
            hoverTimer = setTimeout(() => {
              wrapper.classList.add('is-active');
              
              isZooming = true;
            }, 300);
          });

          lens.addEventListener('mousemove', (event) => {
            
            if (isZooming) {
              moveLens(event);
            }
          });
          
          wrapper.addEventListener('mouseleave', () => {
            wrapper.classList.remove('is-active');
            
            clearTimeout(hoverTimer);
            isZooming = false;
          });
          
          function moveLens(event) {
            const rect = wrapper.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
          
            // Clamp x/y inside the wrapper
            const clampedX = Math.max(0, Math.min(x, wrapper.clientWidth));
            const clampedY = Math.max(0, Math.min(y, wrapper.clientHeight));
          
            // Get relative position in percentage
            const xPercent = clampedX / wrapper.clientWidth * 100;
            const yPercent = clampedY / wrapper.clientHeight * 100;
            
            lens.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
          }
        }

        payments() {
          const items = document.querySelectorAll('.product-detail .product-payments__item[data-price-calculation="payments"]');

          if (!items.length) {
            return;
          }

          items.forEach((item) => {
            const itemTitle = item.querySelector('.product-payments__item-title');

            document.addEventListener('product:variantChanged', (event) => {
              const itemVariant = item.querySelector(`script[data-variant-id="${event.detail.variant.id}"]`);
              
              if (!itemVariant) {
                return;
              }

              const temp__itemVariant = document.createElement('div');
              temp__itemVariant.innerHTML = itemVariant.innerHTML.trim();
              itemTitle.textContent = temp__itemVariant.querySelector('.product-payments__item-title').textContent;
            });
          });
        }
  
        form() {
          const options = document.querySelectorAll('.product-form .option-selector');
  
          if (!options.length) {
            return;
          }

          document.addEventListener('product:variantChanged', (event) => {
            const button = document.querySelector('.product-form .quantity-submit-row .quantity-submit-row__submit button[type="submit"]');
            const stickyButton = document.querySelector('.c-sticky-atc__button');

            if (!button || !stickyButton) {
              return;
            }

            const url = `${window.Shopify.routes.root}cart.json`;

            fetch(url)
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then((data) => {
                const item = data.items.find(product => product.id === event.detail.variant.id);

                if (item) {
                  button.innerHTML = button.dataset.addedToCartText;
                  stickyButton.innerHTML = button.dataset.addedToCartText;
                }
              });
          });
  
          for (var i = 0; i < options.length; i++) {
            const option = options[i];
            const optionIndex = option.getAttribute('data-option-index');
            
            const optionItems = option.querySelectorAll('input[type="radio"]');
    
            if (optionItems.length) {
    
              for (var i2 = 0; i2 < optionItems.length; i2++) {
                const optionItem = optionItems[i2];
                
                optionItem.addEventListener('change', () => {
                  const stickyBarWrapper = document.querySelector('.c-sticky-atc');

                  const event = new CustomEvent('product:stickyBar');
                  stickyBarWrapper.dispatchEvent(event);
                });
              }
            }
          }
        }
  
        optionSelector() {
          const obj = this;
          
          obj.optionSelector__event();
          
          document.addEventListener('scroll', () => {
            obj.optionSelector__event();
          });
        }
  
        optionSelector__event() {
          const obj = this;
          
          const optionSelector = document.querySelector('.option-selector-fieldset[data-size-selector] .option-selector__btns');
  
          if (!optionSelector) {
            return false;
          }
  
          const windowWidth = window.innerWidth;
  
          if (optionSelector.classList.contains('is-animating') || optionSelector.classList.contains('is-animated') || windowWidth >= 768 || optionSelector.scrollWidth <= windowWidth) {
            return false;
          }
          
          const scrollTop = document.querySelector('html').scrollTop;
  
          const optionSelector__react = optionSelector.getBoundingClientRect();
  
          if (scrollTop + window.innerHeight / 2 > optionSelector__react.top + optionSelector.offsetHeight) {
  
            setTimeout(() => {
              optionSelector.classList.add('is-animating');
              
              setTimeout(() => {
                optionSelector.classList.add('is-animated');
                optionSelector.classList.remove('is-animating');
              }, 2000);
            }, 1000);
          }
        }
  
        stickyBar() {
          const wrapper = document.querySelector('.c-sticky-atc');
          
          var lastScrollTop = window.pageYOffset;
          
          document.addEventListener('scroll', e => {
  
            if (window.pageYOffset != lastScrollTop) {
              const activeDropdown = wrapper.querySelector('.c-sticky-atc__selector-dropdown.is-active');
  
              if (activeDropdown) {
                activeDropdown.classList.remove('is-active');
              }
            }
          });
  
          const dropdowns = document.querySelectorAll('.c-sticky-atc__selector-dropdown');
    
          if (dropdowns) {
            
            for (var i = 0; i < dropdowns.length; i++) {
              const dropdown = dropdowns[i];
              const dropdownIndex = dropdown.parentNode.getAttribute('data-index');
              
              const dropdownLabel = dropdown.querySelector('.c-sticky-atc__selector-dropdown__label');
  
              dropdownLabel.addEventListener('click', () => {
                const activeDropdown = wrapper.querySelector('.c-sticky-atc__selector-dropdown.is-active');
  
                dropdown.classList.toggle('is-active');
  
                if (activeDropdown) {
                  activeDropdown.classList.remove('is-active');
                }
              });
              
              const dropdownLabelColor = dropdownLabel.querySelector('.c-sticky-atc__selector-dropdown__label-color');
              const dropdownLabelTitle = dropdownLabel.querySelector('.c-sticky-atc__selector-dropdown__label-title');
              
              const dropdownItems = dropdown.querySelectorAll('.c-sticky-atc__selector-dropdown__item');
              
              for (var i2 = 0; i2 < dropdownItems.length; i2++) {
                const dropdownItem = dropdownItems[i2];
    
                dropdownItem.addEventListener('click', () => {
                  dropdown.classList.remove('is-active');
                  const dropdownItemValue = dropdownItem.getAttribute('data-value');
  
                  const dropdownActiveItem = dropdownItem.parentNode.querySelector('.is-active');
                  
                  dropdownItem.classList.add('is-active');
    
                  if (dropdownActiveItem) {
                    dropdownActiveItem.classList.remove('is-active');
                  }
                  
                  const dropdownItemColor = dropdownItem.querySelector('.c-sticky-atc__selector-dropdown__item-color');
  
                  if (dropdownLabelColor && dropdownItemColor) {
                    dropdownLabelColor.setAttribute('data-swatch', dropdownItemColor.getAttribute('data-swatch'));
                  }
                  
                  const dropdownItemTitle = dropdownItem.querySelector('.c-sticky-atc__selector-dropdown__item-title');
                  dropdownLabelTitle.innerHTML = dropdownItemTitle.innerHTML;
  
                  const formField = document.querySelector(`.option-selector[data-option-index="${dropdownIndex}"] input[type="radio"][value="${dropdownItemValue}"]`);
  
                  if (formField && !formField.checked) {
                    formField.click();
                  }
                });
              }
            }
          }
          
          const event = new Event('product:sticky-bar:refresh');
          
          wrapper.addEventListener('product:sticky-bar:refresh', (e) => {
            const form = document.querySelector('.product-form');
            
            const options = form.querySelectorAll('.option-selector');
    
            if (options.length) {
  
              for (var i = 0; i < options.length; i++) {
                const option = options[i];
                const optionIndex = option.getAttribute('data-option-index');
                
                const optionItems = option.querySelectorAll('input[type="radio"]');
  
                if (optionItems.length) {
                  
                  for (var i2 = 0; i2 < optionItems.length; i2++) {
                    const optionItem = optionItems[i2];
                    const optionItemValue = optionItem.value;
        
                    const stickyBarDropdownItem = document.querySelector(`.c-sticky-atc__selector[data-index="${optionIndex}"] .c-sticky-atc__selector-dropdown__item[data-value="${optionItemValue}"]`);
  
                    if (stickyBarDropdownItem) {
      
                      if (optionItem.classList.contains('is-unavailable')) {
                        stickyBarDropdownItem.classList.add('is-disabled');
                      }
                      
                      if (optionItem.checked) {
                        stickyBarDropdownItem.click();
                        stickyBarDropdownItem.classList.add('is-active');
                      }
                    }
                  }
                }
              }
            }
  
            wrapper.classList.remove('is-hidden');
            
          }, false);
          wrapper.dispatchEvent(event);
        }
        
        giftCardModal() {
          const obj = this;
              
          document.addEventListener('theme:modal:opened', (event) => {
            const modal = event.detail.modal;
            const modalGiftCard = modal.querySelector('gift-card-modal');
  
            if (!modalGiftCard) {
              return false;
            }
            
            modalGiftCard.render();
          });
  
          document.addEventListener('theme:modal:closed', (event) => {
            const modal = event.detail.modal;
            const modalGiftCard = modal.querySelector('gift-card-modal');
  
            if (!modalGiftCard) {
              return false;
            }
            
            modalGiftCard.unrender();
          });
  
          class GiftCardModal extends HTMLElement {
  
            settings = {
              datepicker: {
                wrapper: this.querySelector('datepicker-wrapper'),
                modal: this.querySelector('datepicker-modal'),
                button: this.querySelector('datepicker-button'),
                bg: this.querySelector('.datepicker-modal__bg'),
                obj: null
              },
              timepicker: {
                selector: this.querySelector('select#gift-card-popup--timepicker')
              }
            }
  
            constructor() {
              super();
  
              const obj2 = this;
            }
  
            render() {
              const obj2 = this;
  
              const formFields = obj2.querySelectorAll('[data-form]');
    
              if (formFields.length) {
    
                formFields.forEach((formField) => {
                  formField.setAttribute('form', formField.getAttribute('data-form'));
    
                  if (formField.hasAttribute('data-required')) {
                    formField.setAttribute('required', 'required');
                  }
                });
              }
  
              obj2.sendOptions__field();
              obj2.datePicker__field();
              obj2.timezone__field();
              obj2.timePicker__field();
              
              obj2.submitButton();
            }
  
            unrender() {
              const obj2 = this;
  
              const formFields = obj2.querySelectorAll('[data-form][required]');
    
              if (formFields.length) {
    
                formFields.forEach((formField) => {
                  formField.removeAttribute('required');
                });
              }
            }
            
            sendOptions__field() {
              const obj2 = this;
  
              const items = obj2.querySelectorAll('.option-selector__btns label');
    
              items.forEach((item) => {
      
                item.addEventListener('click', () => {
                  const itemInput = item.previousElementSibling;
                  itemInput.click();
    
                  const itemValue = item.getAttribute('data-value');
  
                  /* Fields */
                  const fields = obj2.querySelectorAll(`.column.is-active[data-value]`);
                  
                  fields.forEach((field) => {
                    field.classList.add('hidden');
                    field.classList.remove('is-active');
  
                    const fieldInputs = field.querySelectorAll('*[data-name]');
  
                    if (!fieldInputs.length) {
                      return false;
                    }
  
                    fieldInputs.forEach((fieldInput) => {
                      fieldInput.removeAttribute('name');
                    });
                  });
                  /* /Fields */
    
                  /* /Active fields */
                  const activeFields = obj2.querySelectorAll(`.column[data-value="${itemValue}"]`);
  
                  activeFields.forEach((activeField) => {
                    activeField.classList.remove('hidden');
                    activeField.classList.add('is-active');
  
                    const activeFieldInputs = activeField.querySelectorAll('*[data-name]');
  
                    if (!activeFieldInputs.length) {
                      return false;
                    }
  
                    activeFieldInputs.forEach((activeFieldInput) => {
                      activeFieldInput.setAttribute('name', activeFieldInput.getAttribute('data-name'));
                    });
                  });
                  /* /Active fields */
                });
              });
            }
            
            datePicker__field() {
              const obj2 = this;
  
              const currentDate = new Date();
              const nextMonthDate = new Date(new Date().getTime() + 31 * 24 * 60 * 60 * 1000);
    
              const datepickerButtonInput = obj2.settings.datepicker.button.querySelector('input');
              const datepickerButtonText = obj2.settings.datepicker.button.querySelector('span');
    
              obj2.settings.datepicker.button.addEventListener('click', () => {
                obj2.settings.datepicker.wrapper.classList.toggle('is-active');
              });
              
              obj2.settings.datepicker.obj = new Datepicker(obj2.settings.datepicker.modal, {
                minDate: currentDate.getTime(),
                maxDate: nextMonthDate.getTime()
              });
    
              datepickerButtonInput.value = obj2.settings.datepicker.obj.getFocusedDate('d.m.y');
              datepickerButtonText.innerHTML = datepickerButtonInput.value;
    
              obj2.settings.datepicker.modal.addEventListener('changeDate', () => {
                datepickerButtonInput.value = obj2.settings.datepicker.obj.getFocusedDate('d.m.y');
                datepickerButtonText.innerHTML = datepickerButtonInput.value;
  
                obj2.timePicker__field();
                
                obj2.settings.datepicker.wrapper.classList.remove('is-active');
              });
    
              obj2.settings.datepicker.obj.setDate(currentDate);
              
              obj2.settings.datepicker.bg.addEventListener('click', () => {
                obj2.settings.datepicker.wrapper.classList.remove('is-active');
              });
            }
  
            timePicker__field() {
              const obj2 = this;
              
              const selectorOptions = obj2.settings.timepicker.selector.querySelectorAll('option');
  
              selectorOptions.forEach((selectorOption) => {
                selectorOption.disabled = false;
              });
  
              const nowDate = new Date();
              const nowTime = (60 * 60 * nowDate.getHours()) + (60 * nowDate.getMinutes());
  
              if (nowDate.getTime() >= new Date(obj2.settings.datepicker.obj.getDate())) {
                let selectorOption__found = false;
    
                selectorOptions.forEach((selectorOption, selectorOption__i) => {
                  const selectorOption__time = 60 * 30 * selectorOption__i;
    
                  if (selectorOption__found) {
                    return;
                  }
                  
                  if (selectorOption__time < nowTime) {
                    selectorOption.disabled = true;
    
                  } else {
                    selectorOption.selected = true;
                    selectorOption__found = true;
                  }
                });
              }
            }
  
            timezone__field() {
              const obj2 = this;
  
              const field = obj2.querySelector('input[name="properties[_Timezone]"]');
              field.value = Intl.DateTimeFormat().resolvedOptions().timeZone
            }
  
            submitButton() {
              const obj2 = this;
              
              const modalButton = obj2.querySelector('.button--wide[type="button"]');
              
              const formId = modalButton.getAttribute('data-form');
              const form = document.getElementById(formId);
              const formButton = form.querySelector('.button[type="submit"]');
  
              modalButton.innerText = formButton.innerText;
  
              modalButton.addEventListener('click', () => {
  
                if (form.checkValidity()) {
                  const modal = obj2.closest('.cc-modal-window');
                  
                  const modalClose = modal.querySelector('.cc-modal-window__close');
                  modalClose.click();
    
                  formButton.click();
                  
                } else {
                  form.reportValidity();
                }
              });
            }
          }
  
          customElements.define('gift-card-modal', GiftCardModal);
        }

        accordions() {
          const obj = this;

          const accordions = document.querySelectorAll('.product-detail-accordion .cc-accordion-item__panel');

          if (!accordions.length) {
            return;
          }

          accordions.forEach((accordion) => {
            const accordionButton = accordion.querySelector('.product-detail-accordion__button');

            if (!accordionButton) {
              return;
            }

            const accordionContent = accordion.querySelector('.cc-accordion-item__content');

            if (accordionContent.offsetHeight > 153) {
              accordion.classList.add('is--show-more');
            }
          });
        }
      }
    },
    
    sections: {
      
      init: () => {
        const obj = window.themeObj.sections;
      
        new obj.announcementBar();
        new obj.slideshow();
        
        obj.accordions();
      },

      accordions: () => {
        const accordions = document.querySelectorAll('.collapsible-tabs__block .cc-accordion-item');

        if (!accordions.length) {
          return;
        }

        accordions.forEach((accordion) => {
          const accordionTitle = accordion.querySelector('.cc-accordion-item__title');

          if (!accordionTitle) {
            return;
          }

          accordionTitle.addEventListener('click', () => {
            const accordion = accordionTitle.closest('.cc-accordion-item');
            const scrollYBefore = window.scrollY;

            const activeAccordion = accordion.closest('.cc-accordion').querySelector('.cc-accordion-item.is-open');

            if (activeAccordion && activeAccordion != accordion) {
              activeAccordion.classList.remove('is-open');
              activeAccordion.removeAttribute('open');
            }

            setTimeout(() => {
              window.scrollTo({
                top: scrollYBefore,
                behavior: 'smooth'
              });
            }, 500);
          });
        });
      },
    
      announcementBar: class {
  
        data = {}
        
        constructor() {
          const obj = this;
          
          obj.timer();
        }
  
        timer() {
          const obj = this;
  
          class AnnouncementTimer extends HTMLElement {
  
            settings = {
              date: this.getAttribute('data-date')
            }
  
            constructor() {
              super();
              
              const obj2 = this;
              
              obj2.render();
            }
  
            render() {
              const obj2 = this;
              
              obj2.classList.add('is-rendered');
              
              obj2.settings.interval = setInterval(() => {
                obj2.refresh();
              }, 1000);
            }
  
            refresh() {
              const obj2 = this;
  
              const itemTime = new Date(obj2.settings.date).getTime();
            
              const nowTime = new Date().getTime();
              const distanceTime = itemTime - nowTime;
            
              const itemTimeDays = Math.floor(distanceTime / (1000 * 60 * 60 * 24));
              const itemTimeHours = Math.floor((distanceTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const itemTimeMinutes = Math.floor((distanceTime % (1000 * 60 * 60)) / (1000 * 60));
              const itemTimeSeconds = Math.floor((distanceTime % (1000 * 60)) / 1000);
            
              if (distanceTime < 0) {
                obj2.remove();
                clearInterval(obj2.settings.interval);
                
              } else {
                obj2.innerHTML = `${itemTimeDays}d <span>${itemTimeHours < 10 ? 0 : ''}${itemTimeHours}h</span> <span>${itemTimeMinutes < 10 ? 0 : ''}${itemTimeMinutes}m</span> <span>${itemTimeSeconds < 10 ? 0 : ''}${itemTimeSeconds}s</span>`;
              }
            }
          }
          
          customElements.define('announcement-timer', AnnouncementTimer);
        }
      },
      
      slideshow: class {
  
        data = {}
        
        constructor() {
          const obj = this;
          
          obj.timer();
        }
  
        timer() {
          const obj = this;
  
          class SlideshowTimer extends HTMLElement {
  
            settings = {
              date: this.getAttribute('data-date')
            }
  
            constructor() {
              super();
              
              const obj2 = this;
              
              obj2.render();
            }
  
            render() {
              const obj2 = this;
              
              obj2.classList.add('is-rendered');
              
              obj2.settings.interval = setInterval(() => {
                obj2.refresh();
              }, 1000);
            }
  
            refresh() {
              const obj2 = this;
  
              const itemTime = new Date(obj2.settings.date).getTime();
            
              const nowTime = new Date().getTime();
              const distanceTime = itemTime - nowTime;
            
              const itemTimeDays = Math.floor(distanceTime / (1000 * 60 * 60 * 24));
              const itemTimeHours = Math.floor((distanceTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const itemTimeMinutes = Math.floor((distanceTime % (1000 * 60 * 60)) / (1000 * 60));
              const itemTimeSeconds = Math.floor((distanceTime % (1000 * 60)) / 1000);
            
              if (distanceTime < 0) {
                obj2.remove();
                clearInterval(obj2.settings.interval);
                
              } else {
                obj2.innerHTML = `${itemTimeDays}d <span>${itemTimeHours < 10 ? 0 : ''}${itemTimeHours}h</span> <span>${itemTimeMinutes < 10 ? 0 : ''}${itemTimeMinutes}m</span> <span>${itemTimeSeconds < 10 ? 0 : ''}${itemTimeSeconds}s</span>`;
              }
            }
          }
          
          customElements.define('slideshow-timer', SlideshowTimer);
        }
      }
    },

    apps: {

      init: () => {
        const obj = window.themeObj.apps;
        
        obj.rebuy();
        obj.okendo();
        obj.stampedLoyalty();
      },
    
      rebuy: () => {
        const obj = window.themeObj.apps;
        
        class rebuyProductBlock extends HTMLElement {

          constructor() {
            super();
          }

          connectedCallback() {
            const obj2 = this;

            obj2.swatches();
          }

          wishlist() {
            const obj2 = this;
            
            const button = obj2.querySelector('.swym-button');
                  
            const event = new CustomEvent('swym:button:render', {
              detail: {
                button: button
              }
            });
            document.dispatchEvent(event);
          }

          swatches() {
            const obj2 = this;
            
            if (!obj2.hasAttribute('data-product-handle')) {
              return false;
            }

            const url = `${window.Shopify.routes.root}products/${obj2.getAttribute('data-product-handle')}?section_id=rebuy-product-block`;

            fetch(url)
              .then((response) => {
              
                if (!response.ok) {
                  return false;
                }
                
                return response.text();
              })
              .then(response => {
                return new DOMParser().parseFromString(response, 'text/html');
              })
              .then(response => {
                obj2.classList.add('is-rendered');
                
                const fetchedLabels = response.querySelector('.product-label-container');
                const labels = obj2.querySelector('.product-label-container');

                if (fetchedLabels && labels) {
                  labels.innerHTML = fetchedLabels.innerHTML;
                }
                
                const fetchedWishlist = response.querySelector('.product-block-wishlist');
                const wishlist = obj2.querySelector('.product-block-wishlist');

                if (fetchedWishlist && wishlist) {
                  wishlist.innerHTML = fetchedWishlist.innerHTML;
                }
                
                obj2.wishlist();
                
                const fetched__productBlockBase = response.querySelector('.product-block__base');
                const productBlockBase = obj2.querySelector('.product-block__base');

                if (fetched__productBlockBase && productBlockBase) {
                  productBlockBase.innerHTML = fetched__productBlockBase.innerHTML;
                  
                  const event = new CustomEvent('theme:productBlockBase:init', {
                    detail: {
                      productBlockBase: productBlockBase
                    }
                  });
                  document.dispatchEvent(event);
                }
              });
          }
        }
        
        if (!customElements.get('rebuy-product-block')) {
            customElements.define('rebuy-product-block', rebuyProductBlock);
        }

        const bg = document.querySelector('.show-search-form__bg');

        if (bg) {

          bg.addEventListener('click', () => {
            document.body.classList.remove('rebuy__search-popup--opened');
          });
        }
        
        document.addEventListener('rebuy:smartsearch.quickview.ready', (event) => {
          const input = document.getElementById('searchInput');
          
          if (!input) {
            return false;
          }
          
          input.addEventListener('focus', () => {
            document.body.classList.add('rebuy__search-popup--opened');
          });
          
          const close = document.querySelector('.rebuy-quick-view-dropdown__close');
  
          close.addEventListener('click', () => {
            document.body.classList.remove('rebuy__search-popup--opened');
          });

          const search = document.getElementById('rebuy-quick-view-dropdown-search');
          search.style.setProperty('--header-height', `${search.getBoundingClientRect().top}px`);
        });
        
        document.addEventListener('rebuy:smartsearch.quickview.open', (event) => {
          document.body.classList.add('rebuy__search-popup--opened');
        });
      },

      stampedLoyalty: () => {
        const obj = window.themeObj.sections;

        function addEventListenerStamped(el, eventName, handler) {
          if (el.addEventListener) { el.addEventListener(eventName, handler); }
          else { el.attachEvent('on' + eventName, function () { handler.call(el); }); }
        }

        addEventListenerStamped(document, 'stamped:launcher:opened', () => {
          document.body.classList.add('stamped-rewards__popup--opened');
        });
        
        addEventListenerStamped(document, 'stamped:launcher:closed', () => {
          document.body.classList.remove('stamped-rewards__popup--opened');
        });
      },
    
      okendo: () => {
        const obj = window.themeObj.sections;
  
        let interval;
        
        const item = document.querySelector('.announcement-bar [data-oke-all-reviews]');
  
        if (!item) {
          return false;
        }
        
        interval = setInterval(() => {
          const itemOkendoJson = item.querySelector('script[data-oke-metafield-data]');
  
          if (!itemOkendoJson) {
            return false;
          }
  
          const itemOkendo = JSON.parse(itemOkendoJson.innerText);
  
          if (itemOkendo.averageRating > 0) {
            document.body.style.setProperty('--okendo-avarage-rating', `'${itemOkendo.averageRating}'`);
            clearInterval(interval);
          }
          
        }, 500);
      }
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    window.themeObj.init();
  });
  
})();
/* /vDEV */